// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__28PWd","label":"Section_label__1MdoK","contentWrap":"Section_contentWrap__Oa7dJ","footer":"Section_footer__2b_d_","footerInner":"Section_footerInner__3G-8Y"};